import React from 'react';

import styles from './index.module.scss';


export const Portrait = () => (
    <svg className={styles.portrait} viewBox='0 0 43 43' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M21.5 21.5C25.4595 21.5 28.6666 18.2929 28.6666 14.3333C28.6666 10.3737 25.4595 7.16663 21.5 7.16663C17.5404 7.16663 14.3333 10.3737 14.3333 14.3333C14.3333 18.2929 17.5404 21.5 21.5 21.5ZM21.5 25.0833C16.7162 25.0833 7.16663 27.4841 7.16663 32.25V35.8333H35.8333V32.25C35.8333 27.4841 26.2837 25.0833 21.5 25.0833Z' />
    </svg>
);
